import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-28 flex flex-col items-center justify-center text-center">
      <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-500 flex items-center justify-center mb-5">
        <i className="ri-movie-2-line text-3xl"></i>
      </span>
      <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">页面不存在</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600">
        抱歉，你访问的页面可能已被移除或链接有误，去看看热门影视吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-semibold border border-background-300 text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-film-line"></i>
          浏览电影
        </Link>
      </div>
    </div>
  );
}